<ui-dialog
    *ngIf="workersCompensation"
    formDialog
    size="small"
    header="{{ 'payroll.workers-compensation.editRateDetails' | appTranslate }}"
    [scrollable]="true"
    [primaryButtonLabel]="'save' | appTranslate"
    (primaryButtonPressed)="onSave()"
    [open]="displayEditModal"
    (secondaryButtonPressed)="displayModal(false)"
    (closing)="displayModal(false)"
>
    <app-workers-compensation-rate-form
        #form
        [workersCompensation]="workersCompensation"
        [isEditMode]="true"
    ></app-workers-compensation-rate-form>
</ui-dialog>

<app-common-bulk-select-payroll-employee-dialog
    #selectEmployees
    headerText="{{ 'payroll.workers-compensation.assignEmployees' | appTranslate }}"
    [defaultFilters]="{ isWcbExempt: false, eligibleForWcbRateId: workersCompensation.id }"
    [label]="'payroll.workers-compensation.addEmployees'"
>
    <div class="app-grid margin-bottom-4">
        <p style="text-align: left">{{ 'payroll.workers-compensation.selectEmployeesToAssign' | appTranslate }}</p>
    </div>
</app-common-bulk-select-payroll-employee-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true" [backRoute]="getBackRoute()"></app-header>
    <div class="app-grid">
        <ui-card class="columns-8 margin-bottom-5">
            <app-segment-header
                title="{{ 'payroll.workers-compensation.rateDetails' | appTranslate }}"
                (edit)="displayModal(true)"
                [allowEdit]="!route.snapshot.data.isPayrollPending"
            ></app-segment-header>
            <div class="app-grid">
                <div class="columns-3">{{ 'payroll.workers-compensation.rateName' | appTranslate }}</div>
                <div class="columns-9">{{ workersCompensation.name }}</div>
            </div>
            <div class="app-grid margin-top-3">
                <div class="columns-3">{{ 'payroll.workers-compensation.applicableYear' | appTranslate }}</div>
                <div class="columns-9">{{ workersCompensation.year }}</div>
            </div>
            <div class="app-grid margin-top-3">
                <div class="columns-3">{{ 'payroll.workers-compensation.province' | appTranslate }}</div>
                <div class="columns-9">{{ workersCompensation.jurisdiction }}</div>
            </div>
            <div class="app-grid margin-top-3">
                <div class="columns-3">{{ 'payroll.workers-compensation.rate' | appTranslate }}</div>
                <div class="columns-9">{{ workersCompensation.rate | i18nNum }}</div>
            </div>
        </ui-card>
        <app-table
            [useStickyHeader]="false"
            [showSearch]="true"
            [table]="table"
            [showPagination]="true"
            title="{{ 'payroll.workers-compensation.employees' | appTranslate }}"
            [readonly]="route.snapshot.data.isPayrollPending"
        >
            <div class="empty">
                <img style="max-width: 30%" src="/assets/illustrations/magnifying-glass.png" />
                <h2 class="ui centered header">{{ 'payroll.workers-compensation.noEmployeesFound' | appTranslate }}</h2>
            </div>
            <div class="buttons">
                <ui-button class="buttons" type="outline" (click)="onAssign()"
                    >{{ 'payroll.workers-compensation.addRemoveEmployees' | appTranslate }}
                </ui-button>
            </div>
        </app-table>
    </div>
</div>
